<template>
<li id="project_container">
    <div class="top_wrapper">
        <div class="right">
             <div class="tag-mobile" :class="{tut: true}" v-if="item.is_active == '0'">
                    <p >טיוטה</p>
                </div>
            <div class="details_a_logo_container">
                <div class="logo_container"><div class="logo"></div></div>
                <div class="details_a">
                    
                    <div class="address text_item">
                        <h5>שם הפרויקט</h5>
                        <div>
                            <!-- <span v-for="(bld, i) in item.buildings" :key="bld.id" ><a v-text="bld.address + ' ' + bld.num_street"></a> <span v-if="i+1 < item.numbuildingNum">, </span></span>
                            <span class="city" v-text="' - '+item.city"></span> -->
                            
                            <span v-text="item.name"></span>
                        </div>
                    </div>
                    <div class="prj_number_item">
                        <h5>מספר פרויקט</h5>
                        <p v-text="item.prj_number"></p>
                    </div>
                    <div class="building_type_prj_container">
                        <div class="buildings_units_container">
                            <div class="text_item">
                                <div v-text="item.num_building"></div>
                                <h5>בניינים</h5>
                            </div>
                            <div class="text_item">
                                <div v-text="item.num_apartments"></div>
                                <h5>יחידות</h5>
                            </div>
                        </div>
                        <div class="type_prj text_item">
                            <h5>סוג הפרויקט</h5>
                            <div v-text="item.type_parse"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="details_b_status_bar_container">
            <div class="details_b_tag_container">
                <ul class="details_b">
                    <li class="text_item">
                        <h5>מועד יצירת המכרז</h5>
                        <div v-text="item.external_data.date_created_parse"></div>
                    </li>
                    <li class="text_item">
                        <h5>מועד סיום המכרז</h5>
                        <div v-text="item.external_data.date_end"></div>
                    </li>
                    <li class="text_item">
                        <h5>סוג המכרז</h5>
                        <div v-text="(item.is_open == '1' ? 'פתוח' : 'סגור')"></div>
                    </li>
                    <li class="text_item">
                        <h5>מס הצעות</h5>
                        <div v-text="item.external_data.num_offers"></div>
                    </li>
                </ul>
                
                <div class="tag" :class="{tut: true}" v-if="item.is_active == '0'">
                
                    <p >טיוטה</p>

                </div>
            </div>
            <ul class="status_bar">
                <li :class="{selected: +item.status_number === 1}">
                    <div class="icon_container"><div class="icon"></div></div>
                    <span class="text">בהכנה</span>
                </li>
                <li :class="{selected: +item.status_number === 2}">
                    <div class="icon_container"><div class="icon"></div></div>
                    <span class="text">קבלת הצעות</span>
                </li>
                <li :class="{selected: +item.status_number === 3}">
                    <div class="icon_container"><div class="icon"></div></div>
                    <span class="text">נסגר</span>
                </li>
                <li :class="{selected: +item.status_number === 4}">
                    <div class="icon_container"><div class="icon"></div></div>
                    <span class="text">שקלול הצעות</span>
                </li>
                <li :class="{selected: +item.status_number === 5}">
                    <div class="icon_container"><div class="icon"></div></div>
                    <span class="text">הסתיים</span>
                </li>
            </ul>
        </div>
    </div>
    <ul class="actions">
        <li v-tooltip.top="'ברגע שיש הצעה למכרז לא ניתן לערוך'" class="icon_text_container"  :class="{disable: false}">
            <a :href="item.edit_link" class="icon">
                <div class="edit"></div>
            </a>
            <a :href="item.edit_link" class="text">עריכת מכרז</a>
        </li>
        <li v-tooltip.top="'שכפול מכרז'" @click="duplicatePro(item.id)" class="icon_text_container">
            <div  class="icon">
                <div class="duplicate"></div>
            </div>
            <span class="text">שכפול מכרז</span>
        </li>
        <li v-tooltip.top="'שיתוף'" class="icon_text_container">
            <a target="_blank" :href="item.share_link" class="icon">
                <div class="share"></div>
            </a>
            <a target="_blank" :href="item.share_link" class="text">שיתוף</a>
        </li>
        <li v-tooltip.top="'פירוט הצעות'" class="icon_text_container">
            <a :href="item.offers_link" class="icon">
                <div class="change_status"></div>
            </a>
            <a :href="item.offers_link" class="text">פירוט הצעות</a>
        </li>
        
        <li v-tooltip.top="'מחיקת מכרז'" @click="deletePro(item.id)" class="icon_text_container">

            <div  class="icon">
                <div class="delete"></div>
            </div>
            <span class="text">מחיקת מכרז</span>
        </li>
    </ul>
</li>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        deletePro(id) {
            this.confirm(this.get_word('delete_project'), this.get_word('ok_delete'),this.get_word('cancel_delete')).then((result) => {
            if (result) {
               this.$emit('deleteProject', id)
            }
            });
            
        },
        duplicatePro(id) {
            this.confirm("האם אתה בטוח שברצונך לשכפל את המכרז?", "כן","לא").then((result) => {
                if (result) {
                    this.$emit('duplicateProject', id)
                }
            });
        }

    }
}
</script>

<style lang="scss" scoped>
#project_container {display: flex;border-radius: 40px; background: #fff;border: 1px solid transparent;flex-direction: column;
    .top_wrapper { display: flex; flex-direction: row; gap: 16px;}
    &:hover { border: 1px solid var(--text_s);
       
    }
    .text_item { display: flex; flex-direction: column; gap: 10px; line-height: 1;
        h5 {font-size: var(--h5); color: var(--dark_blue); font-weight: 500;}
        div {font-size: var(--h5); color: var(--dark_blue); font-weight: 700;}
    }
    .right { flex: 3; padding: 8px;
        .details_a_logo_container { height: 100%; width: 100%; padding: 30px; display: flex; gap: 16px; border-radius: 32px; border: 1px solid var(--pageBG); background: var(--gray); 
            .logo_container { width: 40px; height: 40px; padding: 8px; background: var(--dark_blue); border-radius: 100%;
                .logo {background-position: center center; background-size: contain; background-repeat: no-repeat; background-image: url(../assets/building.svg); width: 100%; height: 100%;}
            }
            .details_a { display: flex; flex-direction: column; justify-content: space-between;
                .address {}
                .prj_number_item { display: flex; gap: 10px;    align-items: center;
                    h5 { color: var(--dark_blue);}
                    p { color: var(--text_s); font-size: var(--h6); line-height: 1;}
                }

                .building_type_prj_container { display: flex; flex-direction: column; gap: 10px;
                    .buildings_units_container { display: flex; gap: 15px;
                        >div {display: flex; flex-direction: row; align-items: center; gap: 5px;}
                    }
                    .type_prj {display: flex; flex-direction: row; gap: 5px; 
                        div {font-weight: 400;}
                        h5  { color: var(--text_s);}
                        div, h5 { font-weight: 500;}
                    }
                }

            }
        }
    }
    .details_b_status_bar_container { flex: 7; display: flex; flex-direction: column; gap: 56px; padding: 30px;
        .details_b_tag_container { display: flex; padding-right: 55px; gap: var(--gap);
            @include mobile {
                flex-direction: column;
                padding:5px;
                gap:10px;
            .tag.tut{
                display: none;
            }
            }
            .details_b {display: flex; gap: 40px; 
                 @include mobile {
                     gap: 10px;
                     flex-direction: column;
                }
                .text_item {
                    h5 { color: var(--text_s);}
                }
            }
            .tag-mobile{
                display: none;
            }
            
        }
        
    }
    .actions { display: flex; border-right: 1px solid var(--pageBG);
        @include mobile {flex-direction: row;width: 100%;height: 60px;}
        display: flex; align-items: center; justify-content: center; gap: 16px; 
        li { cursor: pointer; 
            // .icon {display: none;}
        }
    }
    .actions {      gap: 30px;padding: 20px;
        .icon_text_container{
            &{display: flex;align-items: center;gap: 10px;}
           .text { font-size: var(--h5); color: var(--dark_blue); font-weight: 500;line-height: 1;}
        }
            li {
                &.disable { background: var(--gray); cursor: default;
                    a { pointer-events: none;}
                }
                .icon {width: 34px; height: 34px; background: E4E4E7; ;border-radius: 50%; display: block; background-size: contain; background-repeat: no-repeat; background-position: center center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #E4E4E7;border-radius: 50%;background-repeat: no-repeat;
                }
                & .share  {background-image: url(../assets/share.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .change_status {background-image: url(../assets/stages.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .edit {background-image: url(../assets/edit.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .delete {background-image: url(../assets/trash.svg); width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .duplicate {background-image: url(../assets/copy.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
            }
        }
    // .prj_data_container {
    //     li { display: flex; flex-direction: column; gap: 10px;
    //         h5 {color: #8E8E8E;}
    //         >div {color: #333;}
    //     }
    // }
    // .right { border-left: 1px #333 solid; width: 250px;
    //     --local_gap: 15px;
    //     ul {  display: flex; flex-wrap: wrap; gap: var(--local_gap);
    //         li {flex-basis: calc(50% - var(--local_gap)); max-width: calc(50% - var(--local_gap));}
    //     }
    // }
    // .details { flex: 1; display: flex; flex-direction: column; gap: 30px;  padding: 20px; position: relative;
    //     .status { display: flex; flex-direction: column;
    //         h4 {}
    //         ul {
    //             li {display: flex; align-items: center; flex-direction: row;
    //                 &::after{ content: '---'; display: block;}
    //                 &:last-child {
    //                     &::after {display: none;}
    //                 }
    //                 & { color: #999;
    //                     i, svg {font-size: 22px;}
    //                 }
                    
    //                 &.selected ~ li, &.selected { color: #333;
    //                     .icon { border-radius: 50%; border: #333 1px solid; width: 13px; height: 13px;
    //                         i, svg {display: none;}
    //                     }
    //                 }
    //                 &.selected {
    //                     font-weight: 600;
    //                 }
                    
    //             }
    //         }

    //     }
    // }
    // .tag_actions { padding: 20px; display: flex; flex-direction: column; justify-content: space-between;
    //     .tag {background: #F5F5F5; display: flex; gap: 5px; border-radius: 25px; padding: 7px 25px;
    //         .num {color: #333; font-weight: 600;}
    //         .msg {color: #333; white-space: nowrap;}
    //     }
    //     .actions_btns { transition: 0.2s all ease; opacity: 0; display: flex; justify-content: center; gap: 10px;
    //         >div { cursor: pointer; display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 50%; background: #eee;
    //             &:hover {background: #ddd;}
    //             i, svg {font-size: 15px;}
    //         }
    //     }
    // }
    @include mobile {
        flex-direction: column;
         border: 1px solid var(--text_s);
            .actions {  gap: 8px;
                li {width: 34px; height: 34px; background: #E4E4E7; padding: 8px;
                    &.disable { background: var(--gray); cursor: default;
                        a { pointer-events: none;}
                    }
                    .icon { width: 100%; height: 100%; display: block; background-size: contain; background-repeat: no-repeat; background-position: center center; }
                    &.share .icon {background-image: url(../assets/share.svg);}
                    &.change_status .icon {background-image: url(../assets/stages.svg);}
                    &.edit .icon {background-image: url(../assets/edit.svg);}
                    &.delete .icon {background-image: url(../assets/trash.svg);}
                    &.duplicate .icon {background-image: url(../assets/copy.svg);}
                }
            }
        
    }
}
@media (max-width: 768px) {
    #project_container {
        
        align-self: center;
        width: 100%;
        height: fit-content;
        padding-bottom: 20px;
        .top_wrapper { flex-direction: column; }
        .details_b_status_bar_container { padding: 0px 0 10px 0; }
        .right { 
            border-radius: 40px;
            padding: 16px;
            width: 100%;

            .tag-mobile.tut{
                position: relative;
                align-content: center;
                top:40px;
                right:5%;
                background:#E4E4E7;
                padding:1px 10px;
                width: fit-content;
                border-radius: 10px;
                p{
                    font-size:18px !important;
                }
                
            }

            .details_a{
                gap: 15px;

                .prj_number_item, .buildings_units_container, .type_prj{
                    justify-content: space-around;
                }
            }
            .address{
                gap:5px;
            }
            .details_a_logo_container { flex-direction: column; align-items: center; text-align: center;
                padding: 20px; gap: 20px;
            }
        }
        .details_b_status_bar_container {
           
            gap:20px;
           .details_b_tag_container{
            display: flex;
            padding: 0;
            justify-content: center;
            width: 100%;
            align-self: center;
            .details_b{
            padding: 0 10px;
            width:80%;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: space-between;
            align-items: stretch;
            align-self: center;
            gap: 10px;
                li{
                    flex-basis: calc(50% - 10px);
                    margin-bottom: 10px;
                }
            }     
         }

         .status_bar{
            justify-content: space-between;
            
            li {
                flex-direction: column;
                font-size: 15px;
                

                .text{
                    font-size: 15px;
                }
                
            span {
            color: var(--dark_blue);
            font-weight: 500;
            align-self: center;
            width: min-content;
            
             }
            }
            li.selected{
                .text{
                    font-weight: 700;
                }
                
            }
        } 
    
        }
        
        .actions {    
              gap: 0px;
              align-items: stretch;
              justify-content: space-between;
              height: fit-content;
              
        .icon_text_container{
                
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    height:auto;
                    gap: 10px;
                    background-color: transparent;
                    width: fit-content;

                    .icon{
                        align-self: center;
                    }
                
            .text { 
                font-size: 15px; 
                color: var(--dark_blue); 
                font-weight: 500;
                line-height: 1;
                align-items: stretch;
                text-align: center;
                height:max-content
            }
        }
            li {
                &.disable { background: var(--gray); cursor: default;
                    a { pointer-events: none;}
                }
                .icon {width: 34px; height: 34px; background: E4E4E7; ;border-radius: 50%; display: block; background-size: contain; background-repeat: no-repeat; background-position: center center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #E4E4E7;border-radius: 50%;background-repeat: no-repeat;
                }
                & .share  {background-image: url(../assets/share.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .change_status {background-image: url(../assets/stages.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .edit {background-image: url(../assets/edit.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .delete {background-image: url(../assets/trash.svg); width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
                & .duplicate {background-image: url(../assets/copy.svg);width: 70%; height: 70%;background-repeat: no-repeat;background-position: center center;}
            }
        }
    }
}
</style>